import NotificationMessageContent from "./notificationMessageContent";

export default class GroupNotificationContent extends NotificationMessageContent {
    groupId = '';
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/message/notification/groupNotification.js